import { api } from "@/convex/_generated/api";
import { useQuery } from "convex/react";
import { useEffect, useMemo } from "react";
import { useDeferredPublicEnhancement } from "@/hooks/use-deferred-public-enhancement";
import {
  readInitialPublicBranding,
  resolvePublicBranding,
} from "@/lib/public-branding";

export default function BrandFavicon() {
  const ready = useDeferredPublicEnhancement();
  const initialBranding = useMemo(() => readInitialPublicBranding(), []);
  const liveBranding = useQuery(
    api.crm.branding.getPublic,
    ready && !initialBranding ? {} : "skip",
  );
  const branding = resolvePublicBranding(initialBranding, liveBranding);

  useEffect(() => {
    if (!branding) return;
    const setIcon = (
      selector: string,
      input: {
        rel: string;
        href: string;
        sizes?: string;
      },
    ) => {
      let link = document.head.querySelector<HTMLLinkElement>(selector);
      if (!link) {
        link = document.createElement("link");
        link.rel = input.rel;
        document.head.append(link);
      }
      link.href = input.href;
      link.type = "image/png";
      if (input.sizes) link.sizes = input.sizes;
    };
    setIcon('link[rel="icon"][sizes="16x16"]', {
      rel: "icon",
      href: branding.favicon16Url,
      sizes: "16x16",
    });
    setIcon('link[rel="icon"][sizes="32x32"]', {
      rel: "icon",
      href: branding.favicon32Url,
      sizes: "32x32",
    });
    setIcon('link[rel="apple-touch-icon"]', {
      rel: "apple-touch-icon",
      href: branding.appleTouchIconUrl,
      sizes: "180x180",
    });
    const manifest = document.head.querySelector<HTMLLinkElement>(
      'link[rel="manifest"]',
    );
    if (manifest) {
      const version = branding.updatedAt
        ? encodeURIComponent(branding.updatedAt)
        : "default";
      manifest.href = `/app.webmanifest?v=${version}`;
    }
  }, [branding]);

  return null;
}
